// Call DP Service to send the email from the Contact page
import config from '../config';

async function SubmitEmail(userName, userEmail, userSubject, userMessage) {
  const apiKey = config.apiKey;
  const apiUrl = config.apiUrl;
  const apiBasePath = config.apiBasePath;

  const requestBody = {
    name: userName,
    email: userEmail,
    subject: userSubject,
    message: userMessage
  };

  return fetch(`${apiUrl + apiBasePath}contact`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-Api-Key': apiKey
    },
    body: JSON.stringify(requestBody)
  })
    .then(response => {
      if (response.status === 403) {
        throw new Error('Unauthorized to make this request.');
      }
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .catch(error => {
      console.error('Error sending email:', error);
      throw error;
    });  
}

export default SubmitEmail;
